import { FC, useEffect, useState } from 'react'
import Chat from './Chat'

import SocketContext from 'src/socket/socket-context'
import { io, Socket } from 'socket.io-client'

const ChatEntry: FC = () => {
  const [socket, setSocket] = useState<Socket | null>(null)

  useEffect(() => {
    const url = new URL(process.env.REACT_APP__SOCKET__URL as string, window.location.origin)
    url.pathname = process.env.REACT_APP__SOCKET__SUPPORT_NAMESPACE as string

    setSocket(io(url.toString(), {
      path: process.env.REACT_APP__SOCKET__PATH,
      auth: {
        authorization: `Bearer ${localStorage.getItem('authToken') ? `${localStorage.getItem('authToken')}` : ''}`,
      },
      transports: ['websocket'],
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!socket) {
    return null
  }

  return (
    <SocketContext.Provider value={{ socket }}>
      <Chat />
    </SocketContext.Provider>
  )
}

export default ChatEntry
